<template>
  <div class="our_partners">
      <div class="container">
          <h1>Our Partners</h1>
          <div class="partners">
              <div class="partners__item" v-for="item in partners ">
                  <img :src="item.url">
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    name:"partners",
    data(){return{

        
// APPLE SAMSUNG HP LG DELL LENOVO SONY ASUS GOOGLE MICROSOFT SHARP TOSHIBA ACER
        partners:[
        // {name:'Apple',url:'./static/apple.svg'},
        {name:'Samsung',url:'./static/samsung.svg'},
        {name:'HP',url:'./static/hp.svg'},
         {name:'LG',url:'./static/LG_logo_(2015).svg'},
        {name:'Dell',url:'./static/Dell_Logo.svg'},
         {name:'Lenovo',url:'./static/Lenovo_logo_2015.svg'},
        {name:'Sony',url:'./static/Sony_logo.svg'},
        {name:'ASUS',url:'./static/ASUS_Logo.svg'},
        {name:'google',url:'./static/Google__G__Logo.svg'},
         {name:'Microsoft',url:'./static/Microsoft_logo_(2012).svg'},
        {name:'Sharp',url:'./static/Logo_of_the_Sharp_Corporation.svg'},
         {name:'Toshiba',url:'./static/Toshiba_logo.svg'},
        {name:'Acer',url:'./static/Acer_2011.svg'},

        // {name:'Jira',url:'./static/jira.svg'},
        // {name:'AWS',url:'./static/aws.svg'},
        // {name:'Aurelia Ventures',url:'./static/av.svg'},

        ]
                  
    }},
    mounted(){
    }

}
</script>

<style lang="scss">
.partners {
    display: flex;
    flex-wrap: wrap;
}

.partners__item {
    width: calc(100% / 7);
    display: flex;
    padding: 30px;
    @media screen and (max-width:1000px) {
         width: calc(100% / 4);
    }
    @media screen and (max-width:768px) {
         width: calc(100% / 3);
    }
}

.partners__item img {
    margin: auto;
}

.our_partners h1 {
    font-size: 35px;
    font-weight: 300;
    color: white;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Page/Client/partners.vue